<template>
  <div class="page-wrapper">
    <div style="width: 960px" v-if="step === 1">
      <div class="mod-tit">
        请选择证书生成方式：
      </div>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="box-card" shadow="hover" @click="selectCreateType(1)">
            <h3>时尚产业联盟（长三角）</h3>
          </div>
          <div style="margin-top: 8px; color: #666">说明：从衣加加认证企业中同步</div>
        </el-col>
        <el-col :span="8" >
          <div class="box-card" shadow="hover"  @click="selectCreateType(2)">
            <h3>独立颁发证书</h3>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="width: 960px" v-if="step === 2">
      <createForm
        :type="createType"
        :company-info="selectedCompanyObj"
        @cancel="cancelCertificate"
        @confirm="confirmCertificate"
      />
    </div>

    <!-- 新增主体类型 -->
    <el-dialog 
      title="选择企业" 
      :visible.sync="selectCompanyDialogVisible" 
      width="600px" 
      center
    >
      <el-select 
        style="width: 400px"
        v-model="selectedCompany"
        filterable
        remote
        placeholder="请输入关键词"
        :remote-method="getCompanyList"
        :loading="selectLoading"
      >
        <el-option
          v-for="item in companyOptions"
          :key="item.company_id + '-' + item.user_id"
          :label="item.company_name"
          :value="item.company_id + '-' + item.user_id"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="selectCompanyHandle">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import createForm from './component/createForm.vue'
import { utils } from "@/common/common.js";
import { request, api } from '@/common/request_course.js';
import { DEFAULT_CERTIFICATE_NAME } from "./util/constant.js";
export default {
  computed: {
    adminId() {
      return utils.getAdminId()
    },
  },
  data() {
    return {
      step: 1, // 步骤
      createType: '', // 1 - 从衣加加认证企业中同步  2 - 独立颁发证书

      // 选择企业
      selectCompanyDialogVisible: false,
      companyOptions: [],
      selectLoading: false,
      selectedCompany: '',
      selectedCompanyObj: {},
    }
  },
  components: { createForm },
  inject: ['reload'],
  methods: {
    getCompanyList(query) {
      this.selectLoading = true
      request({
        url: api.baseUrl + "/yijiajiaCompanyInfo/pageList",
        method: "get",
        params: {
          current: 1,
          size: 20,
          keyword: query,
        }
      }).then(res => {
        this.selectLoading = false
        console.log(res);
        if (res.erroyCode == 200) {
          this.companyOptions = res.data
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      }).catch((err) => {
        this.selectLoading = false
        console.log(err);
      })
    },
    selectCompanyHandle() {
      if (!this.selectedCompany) return this.$message.error('请先选择企业')
      let ids = this.selectedCompany.split('-')
      let selectResult = this.companyOptions.find(item => item.company_id == ids[0] && item.user_id == ids[1])
      console.log(selectResult)
      this.selectedCompanyObj = selectResult
      this.step = 2
      this.createType = 1
      this.selectCompanyDialogVisible = false
    },
    // 选择生成方式
    selectCreateType(type) {
      console.log(type)
      if (type == 1) {
        this.selectCompanyDialogVisible = true
        this.getCompanyList()
      }

      if (type == 2) {
        this.createType = type
        this.step = 2
      }
    },
    // 取消
    cancelCertificate() {
      this.reload()
    },
    confirmCertificate(formData) {
      console.log('form', form)
      let form = formData.form
      let fzzhtMemberCertificates = formData.fzzhtMemberCertificates.map(item => {
        let r = {...item}
        delete r.showUrl
        if (r.type !== DEFAULT_CERTIFICATE_NAME) {
          delete r.number
        } 
        return r
      })
      let params = {}
      let fzzhtMemberInfo = {
        createBy: this.adminId,
        businessLicenseNo: form.businessLicenseNumber,
        businessScope: form.businessScope,
        contactName: form.contactName,
        contactPhoneNumber: form.contactTel,
        desc: form.introduction,
        gender: form.sex,
        position: form.job,
        principalName: form.subjectName,
        principalType: form.subjectType,
        productLabel: form.goodsTag,
        responsiblePersonIdNumber: form.idNumber,
        source: form.resource,
        companyId: form.companyId,
        userId: form.userId,
        registerMobileNumber: form.registerMobileNumber
      }
      params = {
        fzzhtMemberInfo,
        fzzhtMemberCertificates,
      }
      console.log(params)
      request({
        url: api.baseUrl + "/certificate/fzzht-member-info/save",
        method: "post",
        data: params
      }).then(res => {
        console.log(res);
        if (res.erroyCode == 200) {
          this.$confirm('颁发成功', '提示', {
            confirmButtonText: '查看列表',
            cancelButtonText: '继续添加',
            type: 'success',
            center: true,
            closeOnClickModal:false,
            showClose: false,
          }).then(() => {
            this.$router.push('/certificate/list')
          }).catch(() => {
            this.reload()
          })
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      }).catch((err) => {
        console.log(err);
      })
    },
  }
}
</script>

<style scoped lang="scss">
.page-wrapper {
  background: #fff;
  padding: 16px;
  margin: 10px;
  box-sizing: border-box;
  min-height: calc(100vh - 74px);
  .mod-tit {
    font-size: 15px;
    margin-bottom: 16px;

  }
  .box-card {
    padding: 20px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    overflow: hidden;
    color: #303133;
    transition: .3s;
    text-align: center;
    cursor: pointer;
    &:hover {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/certificate/add.vue